import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})

export class LocationService {
  constructor(private http: HttpClient) { }


  updateDeliveryLocation(payload: {
    sub_delivery_id: number;
    lat: number;
    lng: number;
  }): Observable<any> {
    return this.http.post(`${environment.Server_URL}/delivery/update-location`, payload);
  }


  getDeliveryLocation(subDeliveryId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/delivery/location/${subDeliveryId}`);
  }
  getAllDriversLocations(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/admin/delivery-heroes/locations`);
  }

}
